import React, { useState, useEffect } from 'react';
import "./about-us.css";
import Carousel from 'react-bootstrap/Carousel';
import 'react-multi-carousel/lib/styles.css';
import AboutUs2 from '../../assets/images/about-us2.png'
import AboutUs3 from '../../assets/images/about-us3.png'
// svgs
import { Col, Form } from 'react-bootstrap';
import SecondaryBanner from '../banner/secondary-banner';
import { getAboutUs, imgBaseUrl2 } from '../../utils/api'
import Loader from '../../components/loader/dotloader'

const AboutUs = () => {
  const [foundUs, setFoundUs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchFoundUs = async () => {
      try {
        setLoading(true)
        const pay = { pageSize: 0, pageIndex: 0 };
        const res = await getAboutUs(pay);
        if (res.data.isSuccess) {
          const items = res.data.data.items;
          setFoundUs(items);
          setLoading(false)
        }


      } catch (error) {
        setLoading(false)
        console.error('Error fetching products:', error);
      }
    };
    fetchFoundUs();
  }, []);
  return (
    <div>
      {loading && <Loader isLoading={loading} />}
      <div>
        <SecondaryBanner slug='aboutUs1' />
      </div>

      <section className='about-page' style={{ position: 'relative' }}>
        <div className='tab-home mt-5 container'>
          <div className="more-info  mx-0 bg-[#d1e6d2] rounded-[42px] d-flex align-items-center justify-content-between gap-5">
            <div className='row gx-4'>
              <Col md={7} xs={12} className='pr-2'>
                <h1 className='text-2xl font-bold'><span className='text-[#00A14B] text-3xl font-bold'>درباره‌ی</span> طبیعی باش
                </h1>
                {foundUs.map((item, index) => (
                      <div  key={index}>
                      <div className='mt-3 body-item text-[#494C50] text-base fw-500 font-medium ' dangerouslySetInnerHTML={{ __html: item.description}} />

                 </div>
               
                ))}

              </Col>
              <Col md={5} xs={12}>
                <div className="flex flex-col gap-4 items-center justify-center p-3">
                  {foundUs && foundUs[0] && foundUs[0].images.map((item, index) => (
                    <div key={index}>
                      <img src={imgBaseUrl2 + 'io/550x270/' + item.url} alt="" className='about-img' style={{ borderRadius: '25px' }} />

                    </div>
                  ))
                  }

                </div>
              </Col>
            </div>
          </div>


        </div>
      </section>
    </div>
  );
}

export default AboutUs;
